import { render, staticRenderFns } from "./WechatExchangeList.vue?vue&type=template&id=733fbbe4"
import script from "./WechatExchangeList.vue?vue&type=script&lang=js"
export * from "./WechatExchangeList.vue?vue&type=script&lang=js"
import style0 from "./WechatExchangeList.vue?vue&type=style&index=0&id=733fbbe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports